import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import { dateFilter, dateFilterOptions, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';

DialogDownloadDateRangeView.propTypes = {
    filter: PropTypes.object,
    onDownload: PropTypes.func,
};

function DialogDownloadDateRangeView({ filter, onDownload }) {
    const initialRange = getDateFilterOption(dateFilter.baMuoiNgayGanNhat);
    const [loading, setLoading] = useState(false);
    const [selectedPreset, setSelectedPreset] = useState(dateFilter.baMuoiNgayGanNhat);
    const [startDate, setStartDate] = useState(initialRange?.[0]?.format('YYYY-MM-DD') ?? '');
    const [endDate, setEndDate] = useState(initialRange?.[1]?.format('YYYY-MM-DD') ?? '');

    const selectedName = useMemo(
        () => _.find(dateFilterOptions, (i) => i.value === selectedPreset)?.name ?? '30 ngày gần nhất',
        [selectedPreset]
    );

    const handlePresetChange = (value) => {
        setSelectedPreset(value);
        const range = getDateFilterOption(value);
        if (range) {
            setStartDate(range[0]?.format('YYYY-MM-DD') ?? '');
            setEndDate(range[1]?.format('YYYY-MM-DD') ?? '');
        }
    };

    const handleSubmit = async () => {
        const params = _.pickBy(
            {
                ..._.omit(filter, ['limit', 'page']),
                from: startDate,
                to: endDate,
                limit: 1000000,
            },
            (value) => value != null && value !== ''
        );

        try {
            setLoading(true);
            await onDownload(params);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="p-4">
                <KTFormGroup
                    label={UIHelper.buildFormLabel('Chọn khoảng thời gian')}
                    inputName="datePreset"
                    inputElement={
                        <KTBSDropdown
                            toggleElement={
                                <button
                                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                    type="button"
                                >
                                    {selectedName}
                                </button>
                            }
                            selectedValue={selectedPreset}
                            dropdownMenuItems={dateFilterOptions}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={handlePresetChange}
                        />
                    }
                />
                <div className="d-flex align-items-center gap-3">
                    <KTFormGroup
                        label={UIHelper.buildFormLabel('Ngày bắt đầu')}
                        inputName="startDate"
                        additionalClassName="mb-0 flex-grow-1"
                        inputElement={
                            <KTFormInput
                                name="startDate"
                                value={startDate}
                                onChange={(value) => {
                                    if (selectedPreset !== dateFilter.tuyChon) setSelectedPreset(dateFilter.tuyChon);
                                    setStartDate(value);
                                }}
                                type={KTFormInputType.date}
                                placeholder="Ngày bắt đầu..."
                                maxTime={endDate || undefined}
                            />
                        }
                    />
                    <KTFormGroup
                        label={UIHelper.buildFormLabel('Ngày kết thúc')}
                        inputName="endDate"
                        additionalClassName="mb-0 flex-grow-1"
                        inputElement={
                            <KTFormInput
                                name="endDate"
                                value={endDate}
                                onChange={(value) => {
                                    if (selectedPreset !== dateFilter.tuyChon) setSelectedPreset(dateFilter.tuyChon);
                                    setEndDate(value);
                                }}
                                type={KTFormInputType.date}
                                placeholder="Ngày kết thúc..."
                                minTime={startDate || undefined}
                            />
                        }
                    />
                </div>
            </div>
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', () => AppCustomDialogHelper.hide(), null)}
                {UIHelper.buildGreenButton('Tải xuống', handleSubmit, null, false, loading)}
            </div>
        </div>
    );
}

export default DialogDownloadDateRangeView;
